export default __webpack_public_path__ + "static/media/notification.2021a5ea.svg";